import { Button, Dialog } from '@sortlist-frontend/design-system/legacy';
import { useEffect, useState } from 'react';

interface Props {
  keepMounted: boolean;
  value: string;
  open: boolean;
  onClose: (uuid?: string) => void;
  isLoading: boolean;
  title: string;
  description: string;
  okLabel: string;
  cancelLabel: string;
}

export const ConfirmationDialog = (props: Props) => {
  const { onClose, value: valueProp, open, isLoading, title, description, okLabel, cancelLabel, ...other } = props;
  const [value, setValue] = useState(valueProp);

  useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleCancel = () => {
    onClose();
  };

  const handleOk = () => {
    onClose(value);
  };

  return (
    <Dialog
      disableEscapeKeyDown
      maxWidth="xs"
      aria-labelledby="confirmation-dialog-title"
      data-testid="confirmation-dialog"
      closeBtn={false}
      open={open}
      {...other}>
      <div className="px-8 pt-8 pb-4">
        <h1 className="bold h4">{title}</h1>
        <p className="mt-1">{description}</p>
      </div>
      <div className="px-8 pb-8 pt-4 layout-row layout-align-start-start">
        <Button
          label={cancelLabel}
          onClick={handleCancel}
          animation="ripple"
          buttonStyle="secondary"
          buttonVariant="light"
          size="sm"
          id="cancel-btn"
        />
        <Button
          size="sm"
          label={okLabel}
          className="ml-4"
          onClick={handleOk}
          animation="ripple"
          loading={isLoading}
          buttonStyle="danger"
          buttonVariant="light"
          id="ok-btn"
        />
      </div>
    </Dialog>
  );
};
